import React from 'react';

const Loader = () => {
    return (
        <div id="loader" className="loader-holder" style={{display: 'none'}}>
            <div className="ball-loader">
                <div className="ball-loader-ball ball1"/>
                <div className="ball-loader-ball ball2"/>
                <div className="ball-loader-ball ball3"/>
            </div>
        </div>
    );
};

export default Loader;


// WEBPACK FOOTER //
// ./src/common/Loader.js